import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '~utils/cn';

const alertVariants = cva(
  'relative grid w-full grid-cols-[0_1fr] items-start gap-y-1 rounded-lg border px-2 py-3 text-sm shadow-xs has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 [&>svg]:translate-y-[1px]',
  {
    variants: {
      intent: {
        info: 'border-info/40 bg-info/5 text-info',
        success: 'border-success/40 bg-success/5 text-success',
        warning: 'border-warning/40 bg-warning/5 text-warning',
        error: 'border-destructive/40 bg-destructive/5 text-destructive',
        neutral: 'border-border bg-card text-foreground',
      },
    },
    defaultVariants: {
      intent: 'neutral',
    },
  },
);

function Alert({ className, intent, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ intent, className }))} {...props} />;
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="alert-title" className={cn('col-start-2 font-medium', className)} {...props} />;
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn('col-start-2 text-foreground text-sm leading-relaxed', className)}
      {...props}
    />
  );
}

export { Alert, AlertDescription, AlertTitle, alertVariants };
